import { render, staticRenderFns } from "./ProductsLayout.vue?vue&type=template&id=f59bcbb2&scoped=true"
import script from "./ProductsLayout.vue?vue&type=script&lang=js"
export * from "./ProductsLayout.vue?vue&type=script&lang=js"
import style0 from "./ProductsLayout.vue?vue&type=style&index=0&id=f59bcbb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59bcbb2",
  null
  
)

export default component.exports